// extracted by mini-css-extract-plugin
export default {"card":"Card_card__eoZYL","smallText":"Card_smallText__-eV4E","card__label":"Card_card__label__JkHcG","cardInner":"Card_cardInner__BYUZP","card__value":"Card_card__value__UEffS"};